module.exports = __webpack_public_path__ + "static/media/Artboard10.48871b4f.png";